import MultipleProgressBar from './MultipleProgressBar'
export default MultipleProgressBar
